<template>
  <el-dialog
    :title="title"
    :visible="dialogFormVisible"
    :before-close="handleClose"
    width="60%"
  >
    <table-form
      :dataSource="dataSource"
      ref="form"
      :tableData="formData"
      :disable="disabled"
    ></table-form>
    <div class="upload">
      <el-table :data="dataUp" style="width: 100%" border>
        <el-table-column
          type="index"
          label="序号"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="title"
          label="材料名称"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="oldFile"
          label="附件名称"
          width="auto"
        ></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <a href="javascript:void(0);" class="input">
              上传
              <input
                :key="dialogFormVisible"
                type="file"
                class="file"
                @change="getFile($event, scope)"
                accept="application/pdf,image/*,application/x-zip-compressed,application/x-rar-compressed"
              />
            </a>
          </template>
        </el-table-column>
        <el-table-column label="下载附件" width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              :disabled="scope.row.newFile ? false : true"
              @click="downFile(scope.row)"
              style="font-size:14px"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" class="pull-left" @click="allDisabled"
        >编辑</el-button
      >
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import TableForm from "common/components/form/tableForm1";
import { step3 } from "@/conf/newAgency";
import {
  // addUpContactFin,
  singleUpload,
  institutionDownLoadCommon,
  addPersonInfo,
  updateFinanceLinkman,
} from "common/js/api";
export default {
  components: {
    TableForm,
  },

  props: ["dialogVisible", "title", "tableData", "detailId", "codeId", "type"], //falg判断是联系人、负责人

  data() {
    return {
      dataSource: [],
      dialogFormVisible: false,
      formData: {},
      disabled: true,
      dataUp: [
        {
          title: "营业执照/身份证",
          oldFile: "--",
          newFile: "",
        },
        {
          title: "学位/学历材料",
          oldFile: "--",
          newFile: "",
        },
        {
          title: "管理人之间的控制关系图",
          oldFile: "--",
          newFile: "",
        },
        {
          title: "简介",
          oldFile: "--",
          newFile: "",
        },
      ],
      upIndex: 0,
    };
  },

  mounted() {
    this.dataSource = this.$lodash.cloneDeep(step3[2]);
  },

  methods: {
    allDisabled() {
      console.log(this.disabled);
      this.disabled = false;
      if (this.disabled == false) {
        this.$message({
          message: "已开启编辑模式",
          type: "success",
        });
      }
    },
    async downFile(row) {
      // const fileData = row.newFile.split("/");
      // const suffix = fileData[1].split(".");
      // await downLoadCommon(fileData[0], suffix[1], row.oldFile, suffix[0]);
      const filePath = row.newFile;
      const fileName = row.oldFile;
      console.log("@@row", row);
      console.log("@@filePath", filePath);
      console.log("@@fileName", fileName);
      const params = {
        filePath: filePath,
        fileName: fileName,
      };
      await institutionDownLoadCommon(params);
    },

    handleClose() {
      this.dialogFormVisible = false;
      this.resetForm();
      this.$emit("closeDialog");
    },

    handlerSubmitClose() {
      this.dialogFormVisible = false;
      this.resetForm();
      this.$emit("reload");
    },

    async submit() {
      const isValidate = this.$refs.form.submitForm();
      if (!isValidate) return false;
      console.log(this.dataUp);
      let form = this.$refs.form.form;
      form.type = this.type;
      form.personType = 5;
      // 营业执照/身份证;
      form.identifyCardOrignName = this.dataUp[0].oldFile;
      form.identifyCardStorePath = this.dataUp[0].newFile;
      // 学位/学历材料
      form.degreeFileOrignName = this.dataUp[1].oldFile;
      form.degreeFileStorePath = this.dataUp[1].newFile;
      // 管理人之间的控制关系图
      form.controllerRelationOrignName = this.dataUp[2].oldFile;
      form.controllerRelationStorePath = this.dataUp[2].newFile;
      // 简介
      form.abstractInfoOrignName = this.dataUp[3].oldFile;
      form.abstractInfoStorePath = this.dataUp[3].newFile;

      // code id
      form.institutionCode = this.codeId;
      if (this.title.includes("编辑")) {
        form.id = this.tableData.id;
      } else {
        form.id = 0;
      }
      if (this.title.includes("添加")) {
        await addPersonInfo(form);
      } else {
        await updateFinanceLinkman(form);
      }
      // await addUpContactFin(this.title, form);
      this.$message({
        message: `${this.title}成功!`,
        type: "success",
      });
      this.handlerSubmitClose();
    },

    getFile(event, scope) {
      this.upIndex = scope.$index;
      let file = event.target.files[0];
      let fileName = file.name;
      if (file) {
        let idx = fileName.lastIndexOf(".");
        if (idx != -1) {
          let ext = fileName.substr(idx + 1).toUpperCase();
          ext = ext.toLowerCase();
          if (
            // ext != "bmp" &&
            // ext != "jpg" &&
            // ext != "png" &&
            // ext != "jpeg" &&
            // ext != "gif" &&
            // ext != "webp" &&
            // ext != "svg" &&
            // ext != "tiff" &&
            // ext != "pjp" &&
            // ext != "jfif" &&
            // ext != "xbm" &&
            // ext != "dib" &&
            // ext != "jxl" &&
            // ext != "svgz" &&
            // ext != "tif" &&
            // ext != "pjpeg" &&
            // ext != "avif" &&
            ext != "pdf" &&
            ext != "rar" &&
            ext != "zip"
          ) {
            this.$message.error(
              "请上传格式正确的文件，支持pdf、rar和zip"
            );
          } else {
            this.file = file;
            this.oldFile = fileName;
            this.uploadForm(event);
            this.$message({
              type: "success",
              message: "文件上传成功",
            });
          }
        }
      }
    },

    async uploadForm(event) {
      event.preventDefault();
      let formData = new FormData();
      formData.append("file", this.file);
      formData.append("ftCode", this.Cookies.get("selectedBasicFtCode"));
      formData.append("institutionName", this.Cookies.get("institutionName"));
      let loadingInstance = this.$loading({ fullscreen: true });
      let a=setTimeout(() => {
        loadingInstance.close();
      }, 120000);
      const result = await singleUpload(formData);
      clearTimeout(a);
      loadingInstance.close();
      this.dataUp[this.upIndex].oldFile = result.result.orignName;
      this.dataUp[this.upIndex].newFile = result.result.storePath;
      this.$message({
        message: "上传成功",
        type: "success",
      });
    },

    resetForm() {
      this.formData = {};
      this.dataUp.forEach((item) => {
        item.oldFile = "";
        item.newFile = "";
      });
    },

    editSetDetail(tableData) {
      // 营业执照/身份证;
      if (tableData.identifyCardStorePath) {
        this.dataUp[0].oldFile = tableData.identifyCardOrignName;
        this.dataUp[0].newFile = tableData.identifyCardStorePath;
        //学位/学历材料
      }
      if (tableData.degreeFileStorePath) {
        this.dataUp[1].oldFile = tableData.degreeFileOrignName;
        this.dataUp[1].newFile = tableData.degreeFileStorePath;
      }
      // 管理人之间的控制关系图
      if (tableData.controllerRelationStorePath) {
        this.dataUp[2].oldFile = tableData.controllerRelationOrignName;
        this.dataUp[2].newFile = tableData.controllerRelationStorePath;
      }
      // 简介
      if (tableData.abstractInfoStorePath) {
        this.dataUp[3].oldFile = tableData.abstractInfoOrignName;
        this.dataUp[3].newFile = tableData.abstractInfoStorePath;
      }
    },
  },
  watch: {
    dialogVisible(newValue) {
      this.dialogFormVisible = newValue;
      if (newValue && this.title.includes("编辑")) {
        this.editSetDetail(this.tableData);
        this.disabled = true;
      }
      if (this.title.includes("添加")) {
        this.disabled = false;
      }
    },

    tableData: {
      handler(newValue) {
        this.formData = newValue;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.upload {
  padding-top: 30px;
}

/*input*/
.file_name {
  width: 50%;
  text-indent: 10px;
  border: 1px solid #ccc;
  height: 30px;
}

a.input {
  width: 70px;
  /* border-radius: 5px; */
  height: 30px;
  margin-top: 1px;
  vertical-align: top;
  line-height: 28px;
  /* background: #409EFF; */
  /* background: #3091d1; */
  text-align: center;
  display: inline-block;
  overflow: hidden;
  position: relative;
  vertical-align: bottom;
  text-align: left;
}

/* a.input:hover {
  background: #66b1ff;
  color: #ffffff;
} */

a {
  text-decoration: none;
  color: #3165ff;
  position: absolute !important;
  left: 10px;
  top: 10px;
  font-size: 13px;
}

.file {
  opacity: 0;
  /*设置此控件透明度为零，即完全透明*/
  filter: alpha(opacity=0);
  /*设置此控件透明度为零，即完全透明针对IE*/
  font-size: 100px;
  cursor: pointer;
  position: absolute;
  /*绝对定位，相对于 .input */
  top: 0;
  right: 0;
}
</style>
